export const module = {
  info: {
    name: 'jikatel-dialer',
    caption: 'Jikatel Dialer'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel Dialer',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-dialer',
    children: [
      {
        caption: 'Create Dialer',
        icon: 'el-icon-plus',
        routeName: 'module->jikatel-dialer->create'
      },
      {
        caption: 'List Dialers',
        icon: 'el-icon-more-outline',
        routeName: 'module->jikatel-dialer->list'
      }
    ]
  }
}

export default module
